import React, { useEffect, useContext, useCallback, useState } from "react";
import { Filtro } from "./filtro";
import { BooksSection } from "./seccion-libros";
import { FilterCardsContainer } from "./current-filter-buttons";
import { store } from "../components/Store.js";
import { SolicitudDemo } from "../components/solicitud-demo/index.js";
import { useContactRequest } from "../components/solicitud-demo/hook/useContactRequest.js";
import { useTranslations } from "../hooks/use-translations.js";
import { useFilterAndSearchManager } from "./hooks/search.js";
import { Icon } from "@iconify/react";
import { Helmet } from "react-helmet";
import { DropdownOrdenamiento } from "./dropdown-ordenamiento.js";
import { RandomBooksSection } from "./random-books-section.js";
import { useLanguage } from "../hooks/use-language.js";

/**
 * Este es el componente 'index' de Búsqueda, se encarga de realizar toda la lógica de filtrado, fetching de libros y de ordenamiento para ser plasmado en los componentes de presentación como el Filtro, entre otros.
 * @returns
 */
const Busqueda = () => {
	const lang = useLanguage();
	const texts = useTranslations({ section: "busqueda", lang: lang });
	const globalState = useContext(store);
	const isLogged =
		globalState.state.sesionActiva !== null && globalState.state.sesionActiva === "SI";
	const contactRequest = useContactRequest();
	const filterAndSearchManager = useFilterAndSearchManager();
	const filters = filterAndSearchManager?.filters;
	const books = filterAndSearchManager?.data;
	const isLoadingBooks = filterAndSearchManager?.loading;
	const hasBooks = books?.length > 0;
	const getDefaultSortMethod = useCallback(() => {
		if (filters.orderBy.active && filters.orderType.active) {
			const orderType = filters.orderType.paramValue?.toLowerCase();
			const orderBy = filters.orderBy.paramValue?.toLowerCase();
			if (orderType === "asc" && orderBy === "title") {
				return "az";
			}
			if (orderType === "desc" && orderBy === "title") {
				return "za";
			}
			if (orderType === "desc" && orderBy === "duracion") {
				return "mayor-menor";
			}
			if (orderType === "asc" && orderBy === "duracion") {
				return "menor-mayor";
			}
			return "";
		}
	}, [filters]);
	const [shouldShowPagination, setShouldShowPagination] = useState(false);

	useEffect(() => {
		if (isLogged) {
			contactRequest.setVisible(false);
		} else {
			contactRequest.setVisible(true);
		}
	}, []);

	useEffect(()=>{
		const contactRequestIsVisible = contactRequest.state.visible;
		setShouldShowPagination(!contactRequestIsVisible);
	},[contactRequest])



	return (
		<>
			<Helmet>
				<title>{texts?.metadata?.title || "MakeMake- búsqueda avanzada"}</title>
				<meta
					name="description"
					content={
						texts?.metadata?.description ||
						"Encuentra tus próximas lecturas y tus libros favoritos más fácil y rápido con los filtros de búsqueda avanzada."
					}
				/>
			</Helmet>
			<div className="main-container busqueda-container">
				<div className="main-content-2">
					<div className="layout">
						<Filtro
							filterAndSearchManager={filterAndSearchManager}
							loadingData={isLoadingBooks}
						/>
						<>
							<div className="seccion-libros">
								<div className="w-100 h-100 justify-content-center align-items-center">
									<FilterCardsContainer
										filterAndSearchManager={filterAndSearchManager}
									/>
									{!isLoadingBooks ? (
										<>
											{hasBooks ? (
												<BooksSection
													books={books}
													shouldShowPagination={shouldShowPagination}
													sortDropdownSlot={
														<DropdownOrdenamiento
															defaultItemId={getDefaultSortMethod()}
															onChange={(value) => {
																filterAndSearchManager.updateFilters(
																	(draft) => {
																		draft.orderBy.paramValue =
																			value.orderBy;
																		draft.orderType.paramValue =
																			value.orderType;
																		draft.orderBy.active = true;
																		draft.orderType.active = true;
																	}
																);
																filterAndSearchManager.forceSearch();
															}}
														/>
													}
												/>
											) : (
												<RandomBooksSection />
											)}
										</>
									) : (
										<>
											<div className="secondary-inverse--color container-fluid w-100 d-flex justify-content-center align-items-center col-md-10 col-lg-10 mt-5">
												<Icon
													icon="icomoon-free:spinner9"
													width={60}
													className={"spinner-rotation"}
												/>
											</div>
										</>
									)}
								</div>
							</div>
						</>
					</div>
					{contactRequest?.state?.visible && <div className="gradient-demo"></div>}
				</div>
				{contactRequest?.state?.visible && (
					<SolicitudDemo
						className={"busqueda-demo"}
						keepReading={() => contactRequest.setVisible(false)}
						showKeepReadingButton={hasBooks}
						txtButton={texts?.boton?.ver_mas || "ver más libros"}
					/>
				)}
			</div>
		</>
	);
};

export default Busqueda;
